module.exports = __webpack_public_path__ + "static/media/mastercardImage.989c19d7.png";